import { createSelector } from 'reselect';

export const getPromocodeSelector = state => state.promocode;

export const getCodeSelector = createSelector(
  getPromocodeSelector,
  (_state, props) => props.match.params.code || null,
  (promocodeData, locationData) => {
    return locationData || promocodeData.code;
  },
);

export const getResultSelector = createSelector(
  getPromocodeSelector,
  promocodeData => promocodeData.result,
);
